import { NavigationItemState } from "@sb/library/data-models";
import { IconItem } from "./icon.definitions";

export enum SidebarItemState {
    Active = "Active",
    Inactive = "Inactive",
    Hidden = "Hidden",
}

export interface OverflowSidebarItem {
    icon: IconItem;
    navigationTitle: string;
    routerLink: string;
    badgeText?: string | number;
    fragment?: string;
    queryParams?: { [key: string]: any };
    linkActive: SidebarItemState;
    visibility: NavigationItemState;
}